const getNumericValue = (value) =>
    Number.isFinite(value) ? value : Number.isFinite(Number(value)) ? Number(value) : null;

export const formatUsdCost = (value) => {
    const amount = getNumericValue(value);

    if (amount === null) {
        return "-";
    }

    if (amount === 0) {
        return "$0.00";
    }

    if (amount >= 1) {
        return `$${amount.toFixed(2)}`;
    }

    if (amount >= 0.01) {
        return `$${amount.toFixed(4)}`;
    }

    return `$${amount.toFixed(6)}`;
};

export const formatTokenCount = (value) => {
    const amount = getNumericValue(value);
    return amount === null ? "-" : Math.round(amount).toLocaleString();
};

export const getDiscoveryDebugSummary = (debugInfo) => {
    if (!debugInfo) {
        return null;
    }

    const usageSummary = debugInfo.llm_usage_summary || {};
    const costSummary = debugInfo.llm_cost_summary || {};

    const totalUsd = getNumericValue(costSummary.total_usd);
    const pricedCalls = getNumericValue(
        costSummary.priced_calls ?? usageSummary.priced_calls
    );
    const inputTokens = getNumericValue(
        costSummary.input_tokens ?? usageSummary.input_tokens
    );
    const outputTokens = getNumericValue(
        costSummary.output_tokens ?? usageSummary.output_tokens
    );
    const currency = costSummary.currency || "USD";
    const model = costSummary.model || "gemini-2.5-flash";

    if (
        totalUsd === null &&
        pricedCalls === null &&
        inputTokens === null &&
        outputTokens === null
    ) {
        return null;
    }

    return {
        totalUsd,
        pricedCalls,
        inputTokens,
        outputTokens,
        currency,
        model,
    };
};
